import { observable, makeObservable, action } from 'mobx';
// 代码改造---未使用
class ModalStore {
    constructor() {
        makeObservable(this);
    }
    @observable expandModalIds = [];
    @action
    clearExpandModalIds = () => {
        this.expandModalIds = [];
    };
    @action
    removeExpandModalId = (id) => {
        this.expandModalIds = this.expandModalIds.filter((ele) => ele !== id);
    };
    @action
    addExpandModalId = (id) => {
        if (this.expandModalIds.includes(id)) {
            return;
        }
        this.expandModalIds.push(id);
    };
}
export default new ModalStore();
